// extracted by mini-css-extract-plugin
module.exports = {"infoSwitch":"izdDnaT60ec8B1KC-Uzo7","switchButton":"_28QjiC74girpXJnD66yr9F","active":"_1rsMEXOAVdzwJ5hIykjSF9"};